import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { QuestionnaireStatusStore } from '../../../store/QuestionnaireStatusStore';
import { QuestionnaireStatusTable } from './QuestionnaireStatusTable';

export const QuestionnaireStatusSection = () => {
  const { userId } = useParams();
  // a new store per participant, so a running check cannot show its results for another one
  return userId ? (
    <ParticipantQuestionnaires key={userId} userId={userId} />
  ) : null;
};

const ParticipantQuestionnaires = observer(({ userId }: { userId: string }) => {
  const [store] = useState(() => new QuestionnaireStatusStore(userId));

  useEffect(() => {
    store.load();
    return store.dispose;
  }, [store]);

  return (
    <QuestionnaireStatusTable
      questionnaires={store.questionnaires}
      isLoading={store.isLoading}
      loadFailed={store.loadFailed}
      onRetry={store.load}
      checkState={store.checkState}
      isCheckingAll={store.isCheckingAll}
      isAnyCheckRunning={store.isAnyCheckRunning}
      onCheck={(target) => void store.check(target)}
      onCheckAll={() => void store.checkAll()}
    />
  );
});
